// Codes must stay in sync with IncomingWayEnum in digital-auto-db and with the
// chk_sms_campaign_incoming_way CHECK constraint on sms_campaign_incoming_ways.
export interface IncomingWayOption {
    code: string;
    nameKey: string;
}

export const INCOMING_WAYS: IncomingWayOption[] = [
    { code: 'gtp_mobile',        nameKey: 'incomingWay.gtpMobile' },
    { code: 'erp_tp',            nameKey: 'incomingWay.erpTp' },
    { code: 'erp_cc',            nameKey: 'incomingWay.erpCc' },
    { code: 'kiosk',             nameKey: 'incomingWay.kiosk' }
];

export function incomingWayNameKey(code: string): string {
    return INCOMING_WAYS.find(way => way.code === code)?.nameKey ?? '';
}

// Notification time is stored as "HH:mm". There is no time-picker component in this
// project, so the hour and minute are picked from these lists instead.
export const HOURS: string[] = Array.from({ length: 24 }, (_, i) => `${i}`.padStart(2, '0'));

export const MINUTES: string[] = ['00', '15', '30', '45'];
